export const generatePositionOptions = ({
  includePositionGroups = false,
  positionsGroups = [],
  positionsOptions,
  t
}) => {
  const options = [
    ...(includePositionGroups && positionsGroups.length
      ? [
          { value: 'title', label: t('positionsGroups'), isDisabled: true },
          // put value as a negative id to be sure it won't be treated as regular position
          ...positionsGroups.map((group) => ({ value: -group.id, label: group.name })),
          { value: 0, label: '-', isDisabled: true }
        ]
      : []),
    ...positionsOptions
  ];
  return options;
};

export const extractPositionIdsOptions = (inputPositionIds, positionsGroups) => {
  const positionsFromGroup = inputPositionIds
    // Select only negative IDs (groups) and resolve their positions
    .filter((id) => id < 0)
    .map((id) => positionsGroups.find((group) => group.id === -id)?.positionsIds || [])
    .flat();

  // Combine valid positions with group positions and ensure uniqueness
  const positionIds = [
    ...new Set(inputPositionIds.filter((id) => typeof id !== 'number' || id > 0).concat(positionsFromGroup))
  ];
  return positionIds;
};
